import styled from 'styled-components/macro';
import { MD } from '@zendeskgarden/react-typography';
import { variables } from 'theme/variables';
const {
  media_md
} = variables;


export const HeroHeader = styled.div`
  background-color: #fff;
  padding: 0px 0px 10px;
  min-height: 600px;
  @media ${media_md} {
    min-height: 510px;
  }
  @media(max-width: 500px) {
   min-height: 510px;
   margin-bottom: 30px;
  }

`



export const Mission = styled(MD)`
  @media(max-width: 500px) {
    margin-top: 0px;
  }
`



export const Title = styled('span')`
  font-size: 24px;
  line-height: 30px !important;
  display: block;
  @media ${media_md} {
    font-size: 39px;
    line-height: 49px !important;
  }
`

